export default "__VITE_ASSET__9630ed11__"